export enum ReasonOrientationEnding {
  OtherSocialRight = 'Accès autre droit social',
  MovingOut = 'Déménagement',
  MovingOutOutside = 'Déménagement hors collectivité',
  CompensationRunsOut = 'Fin de droits RSA',
  SupportSuspension = "Suspension de l'accompagnement",
  Other = 'Autre',
  Cancellation = 'Annulation IODAS',
  Abandonment = 'Abandon',
  Death = 'Décès',
  HealthOrFamillyObligation = 'Santé, Obligation familiale',
  Reorientation = 'Réorientation',
  Freelancer = "Indépendant, création d'entreprise",
  PermanentContract = 'CDI, CDD de plus de 6 mois',
  ProvosionalContract = 'Interim, CDD de moins de 6 mois',
  HelpEmploymentWithIAE = 'Emploi aidé dont IAE',
  Studies = 'Etudes, formation',
  RSJEnding = 'Fin de droits RSJ',
  LimitAgeReached = 'Age limite atteint',
  RSJTransfer = 'Transfert RSJ',
  UnqualifiedOuting = 'Sortie non qualifiée',
  WorkOrIncomeActivity = `Emploi, Revenu d'activité`,
  Retirement = `Retraite`,
  UnavailableForSupport = `Indisponible pour l'accompagnement`,
}

export const labelsByReasonOrientationEnding: Map<ReasonOrientationEnding, string> = new Map<ReasonOrientationEnding, string>(
  Object.keys(ReasonOrientationEnding).map((x: string) => [x, ReasonOrientationEnding[x]] as [ReasonOrientationEnding, string]),
);
